import { WozCategoriesMap, type WozCategoryCode } from '@footsteps/types';

export function getWozCategoryTitle(categoryCode: string | null): string {
  if (!categoryCode) return 'Bezwaar';
  const entry = WozCategoriesMap[categoryCode as WozCategoryCode];
  return entry?.title ?? categoryCode;
}
